<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
          <el-row>
            <!-- 供应商编号/邀请码 -->
            <el-col :span="8">
              <el-form-item :label="$t('ssrManage.invitationCode')" prop="invitationSupplierCode">
                <el-input v-model="queryCondition.invitationSupplierCode" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 供应商名称-->
            <el-col :span="8">
              <el-form-item :label="$t('ssrManage.supplierName')" prop="supplierName">
                <el-input v-model="queryCondition.supplierName" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 是否正式供应商-->
            <el-col :span="6">
              <el-form-item :label="$t('supplierManage.supplierStatus')" prop="supplierStatus">
                <!--供应商状态-->
                <ic-select clearable table="TM_SUPPLIER" field="SUPPLIER_STATUS" v-model="queryCondition.supplierStatus"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
                        <el-col :span="8">
                            <el-form-item label="Category1" prop="categoryLevel1Id">
                                <el-select v-model="queryCondition.categoryLevel1Id" clearable
                                           @change="changeCategory1()">
                                    <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name"
                                               :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="Category2" prop="categoryLevel2Id">
                                <el-select v-model="queryCondition.categoryLevel2Id" clearable>
                                    <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name"
                                               :value="item.tmCategoryId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button>
      </el-row>
      <el-table :data="tableData" border highlight-current-row class="table" row-key="tmSupplierId" @selection-change="handleSelectionChange" ref="supplierSelectTabel">
        <el-table-column v-if="multipleSelectionFlag" sortable prop="tmSupplierId" type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.tmSupplierId">&nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierCode" :label="$t('settlementUnit.supplierCode')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('ssrManage.supplierName')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierNameEn" :label="$t('ssrManage.supplierEnName')"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import supplierApi from "@/api/supplier/supplier";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";

export default {
  components: { IcSelect },
  name: 'supplier-sel-page',
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    }
  },
  data() {
    return {
      tableData: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        supplierCode: null,
        supplierName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null,
        supplierStatus: null,
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      categoryList1: [],
      categoryList2: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
    this.getCategoryList()
  },
  watch: {
    visible() {
      this.$refs.supplierSelectTabel.clearSelection();
    }
  },
  methods: {
    //查询承运商
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      supplierApi.getResourceList(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
      // if(this.selectRows.length==0){
      //     this.$message({message: "请选供应商", type: "warning"});
      // }else{
      //     this.$emit('subCallMethod', this.selectRows);
      // }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.categoryList2 = []
      this.categoryList3 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
